import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSierraFreightHandoffSkip = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSierraFreightHandoffSkip);
};
